module.exports = __webpack_public_path__ + "components/flag/static/square/to-8f1cff97fc6f94471bc5e634b692ee12.svg";